var i4_Translation = {
	className: '.i4-translations',
	translations: null,

	get: function() {
		if (this.translations === null) {
			this.readJson();
		}

		return this.translations;
	},

	readJson: function() {
		if ($(this.className).length) {
			this.translations = JSON.parse($(this.className)[0].innerHTML);
		} else {
			console.warn('i4 warning: the translation json is missing');
		}
	}
};
